import MANIFESTO from "../images/first.jpg";
import Fund from "../images/fund.png";
import Gain from "../images/gain.png";
import Validate from "../images/validate.png";
import Develop from "../images/develop.png";
import Values from "../images/img2.jpg";
import Matchmaking from "../images/matchmaking.png";
import Fundraising from "../images/fundrasing.png";
import Business from "../images/business.png";
import Technology from "../images/technology.png";
import Idea from "../images/idea.png";
import Cofunder from "../images/co-founder.png";
import Team from "../images/team.png";
import Partner from "../images/partnering.jpg";



export const Home = {
  lauch: {
    title: "Our launch strategy",
    subtitle:
      'With our business creation hub "TTLab," we bring the ideas, the skills, and the necessary capital together to help build your MVP, launch and gain initial traction.  We develop and finance upcoming technology firms, giving entrepreneurs the resources, knowledge, and advice they require to succeed.',
  },
  manifesto: {
    smallText: "OUR MANIFESTO",
    image: MANIFESTO,
    title: "At TTLab Ventures, we help turn the best ideas into successful startups.",
    subtitle:
      "At TTLabs, we specialise in connecting with founders at the pre-idea stage and partnering with them to build innovative startups from the ground up. Our in-house team of experts have the technological know-how to help you build a cutting-edge product or service, while our network of investors and mentors can provide the resources you need to grow and scale your business.",
  },
  flex: [
    {
      image: Validate,
      title: "Step 1: Idea Validation",
      subtitle:
        "We work with you to get feedback and consumer input to validate the idea.",
    },
    {
      image: Develop,
      title: "Step 2: Develop the MVP",
      subtitle:
        "Together we develop the MVP to satisfy user needs and deliver a strong value proposition.",
    },

    {
      image: Gain,
      title: "Step 3: Gain Initial Traction",
      subtitle:
        "We launch the MVP and assess product-market fit while continuously testing and iterating."
    },
    {
      image: Fund,
      title: "Step 4:  Get Funding",
      subtitle:
        "TTLabs will put you through our pipeline of investors where you can start fundraising for the next idea that will change the world",
    }

  ],
  choose: {
    title: "Why Choose TTLabs?",
    subtitle:
      "We're dedicated to helping you find the perfect co-founder for your startup. Our platform is designed to connect you with like-minded individuals who share your passion for entrepreneurship and innovation. We provide in-house technological expertise to help you build your product or service more efficiently and effectively. Our network of investors and mentors can provide the resources you need to grow and scale your business.",
    subtitle:
      "We're committed to your success. We work closely with our founders to ensure they have the support and guidance they need to achieve their goals. Whether you're a first-time founder or an experienced entrepreneur, TTLabs has everything you need to turn your startup dreams into a reality. So why wait? Join our community today and start building the next big thing."
  },

}

export const HowItWorks = {
  flex: [
    {
      image: Idea,
      title: "Idea Validation",
      subtitle:
        "If you have a startup idea but haven't yet assembled a team, TTLabs is the perfect place to start. We work with founders at the pre-idea stage to help them validate and refine their business concept. During this process, you'll have the opportunity to meet other like-minded individuals who share your passion and vision for entrepreneurship.",
    },
    {
      image: Cofunder,
      title: "Co-Founder Matchmaking",
      subtitle:
        "Once your idea is validated, TTLabs will work with you to find the right co-founders to join your team. Our team will help you identify the skills and experience you need to build a strong and diverse team, and we'll connect you with other TTLabs founders who share your vision and can help bring your idea to life.",
    },
    {
      image: Team,
      title: "Build Your Team",
      subtitle:
        "With your co-founders in place, TTLabs will help you build out your team and assemble the skills and experience you need to succeed. We'll provide support and resources to help you recruit top talent, develop your team culture, and create a strong foundation for your startup."
    }

  ],
  values: {
    image: Partner,
    title: "Why Choose TTLabs?",
    subtitle:
      "Partnering with TTLabs means you get access to a wide range of support and resources, from idea validation to co-founder matchmaking and team building. Our experienced team of entrepreneurs, developers, and marketing experts are dedicated to helping you build a successful startup, and our unique approach to venture building means you get personalised attention and support every step of the way.",
  },
}

export const About = {
  values: {
    image: Values,
    title: "Our Values",
    subtitle:
      "At TTLabs, we believe that entrepreneurship is a powerful force for change. We are committed to creating a community of founders who are dedicated to making a positive impact on the world. We value collaboration, innovation, and integrity, and we believe that by working together, we can create a brighter future for everyone.",
  },
  flex: [
    {
      image: Matchmaking,
      title: "Co-founder matchmaking",
      subtitle:
        "Our platform is designed to connect like-minded individuals who share a passion for entrepreneurship and innovation.",
    },
    {
      image: Technology,
      title: "Technology development",
      subtitle:
        "Our in-house team of experts has the technological know-how to help our founders build cutting-edge products and services.",
    },
    {
      image: Fundraising,
      title: "Fundraising support",
      subtitle:
        "We provide our founders with access to our network of investors and mentors to help them secure funding and grow their businesses."
    },
    {
      image: Business,
      title: "Business strategy",
      subtitle:
        "We work closely with our founders to develop effective business strategies and provide guidance and support every step of the way.",
    }

  ],
};